import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";

const UserConsent = ({
    name,
    text,
    checked,
    isEditable=false,
    onChange = () => { } }) => {
    return <div style={{
        fontSize: '10px',
        color: '#1f1f1f',
        display: 'flex',
        alignItems: 'center',
    }}>
        <Checkbox
            checked={checked}
            disabled={!isEditable}
            name={name}
            sx={{
                paddingLeft: 0,
                "& .MuiSvgIcon-root": { fontSize: 20 },
            }}
            onChange={onChange}
        />
        <div>
            {text}
        </div>
    </div>;
};

export default UserConsent;


UserConsent.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  text: PropTypes.node.isRequired,
  onChange: PropTypes.func
};